export enum ImageRecognitionActions {}
